module.exports = __webpack_public_path__ + "img/trust-down2.dfbc838f.png";